export function combineEventHandlers() {
  var handlers = {};
  for (var _len = arguments.length, eventHandlers = new Array(_len), _key = 0; _key < _len; _key++) {
    eventHandlers[_key] = arguments[_key];
  }
  eventHandlers.forEach(eh => {
    Object.entries(eh).forEach(_ref => {
      var [key, func] = _ref;
      if (func) {
        // @ts-expect-error
        if (handlers[key]) {
          // @ts-expect-error
          var oldFn = handlers[key];

          // @ts-expect-error
          handlers[key] = function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            oldFn.apply(this, args);
            func.apply(this, args);
          };
        } else {
          // @ts-expect-error
          handlers[key] = func;
        }
      }
    });
  });

  // @ts-expect-error
  return handlers;
}
//# sourceMappingURL=index.js.map